import { useEffect, useState } from 'react'
import useCustomMutationReactQuery from '../generalHooks/useCustomMutationReactQuery'
import { getUserList, updatePostById } from '../../apiProcess/sampleApi'
import _ from 'lodash'
import { loginProcess, otpProcess } from '@/utility/apiProcess/auth/login'
import { toast } from 'react-toastify'
import { getUpcomingEvents } from '@/utility/apiProcess/events'
import { getCareerField, getCareerLocation, getDetailCareer, getListCareer, postCareer } from '@/utility/apiProcess/career'

const useCareerQuery = () => {
  // get career
	const [careersData, setCareersData] = useState<any>([])
  const {
		isLoading: loadingCareers,
		return_data: rawCareersData,
		startFetch: startCareer,
	} = useCustomMutationReactQuery(getListCareer, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: true,
	})
	useEffect(() => {
		if (!_.isEmpty(rawCareersData)) {
			const data:any = []
			rawCareersData.data.data.map((item: any) => {
				data.push({
					title: item.name_position,
					location: item.location,
					slug: item.slug
				})
			})
			setCareersData(data)
		}
	},[rawCareersData])

	// get career field
	const [careerFieldData, setCareerField] = useState([{
		value: '',
		label: 'All',
		isSelected: true
	}])
	const {
		isLoading: loadingCareerField,
		return_data: careerFieldRawData,
		startFetch: startCareerField,
	} = useCustomMutationReactQuery(getCareerField, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: true,
	})

	useEffect(() => {
		if (!_.isEmpty(careerFieldRawData)) {
			careerFieldRawData.data.data.map((item: any) => {
				setCareerField((prev: any) => [...prev, {
					value: item.divisi,
					label: item.divisi,
					isSelected: false
				}])
			})
		}
	},[careerFieldRawData])

	const handleSelectedField = (index:number, formToState:any, handleFilter:any) => {
		const cloneFormToState = _.cloneDeep(formToState)
    const data = _.cloneDeep(careerFieldData)
		data.map((item:any) => item.isSelected = false)
    data[index].isSelected = true
		cloneFormToState.push({
			name: 'filter[divisi]',
			value: data[index].value
		})

		handleFilter(cloneFormToState, 'filter_data')
    setCareerField(data)
  }

	// get career location
	const [careerLocation, setCareerLocation] = useState<any>([
		{
			value: '',
			label: 'All',
		}
	])
	const {
		isLoading: loadingCareerLocation,
		return_data: careerLocationRawData,
		startFetch: startCareerLocation,
	} = useCustomMutationReactQuery(getCareerLocation, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: true,
	})

	useEffect(() => {
		if (!_.isEmpty(careerLocationRawData)) {
			careerLocationRawData.data.data.map((item: any) => {
				setCareerLocation((prev: any) => [...prev, {
					value: item.location,
					label: item.location,
				}])
			})
		}
	},[careerLocationRawData])

	const [isLoading, setLoading] = useState(true)
	useEffect(() => {
		if(!loadingCareers && !loadingCareerField && !loadingCareerLocation) {
			setLoading(false)
		}
	}, [loadingCareers, loadingCareerField, loadingCareerLocation])


	// get detail career 
	const [careerDetail, setCareerDetail] = useState<any>({})
  const {
		isLoading: loadingDetailCareer,
		return_data: rawDetailCareerData,
		startFetch: startDetailCareer,
	} = useCustomMutationReactQuery(getDetailCareer, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})
	useEffect(() => {
		if (!_.isEmpty(rawDetailCareerData)) {
			console.log(rawDetailCareerData.data.data)
			setCareerDetail(rawDetailCareerData.data.data)
		}
	},[rawDetailCareerData])


	// post career
	const [postDataCallback, setPostCareer] = useState<any>([])
  const {
		isLoading: loadingPostCareer,
		return_data: rawPostData,
		startFetch: startPostCareer,
	} = useCustomMutationReactQuery(postCareer, {
		onError: (error:any) => toast.error(error.data.message),
    isStartOnInit: false,
	})

	return {
		isLoading,
    loadingCareers,
    careersData,
    startCareer,
		careerFieldData,
		handleSelectedField,
		careerLocation,
		startDetailCareer,
		careerDetail,
		startPostCareer,
		rawPostData,
		loadingDetailCareer
	}
}

export default useCareerQuery
